import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InvoiceService } from 'src/app/services/invoice.service';
import { MessageService } from 'primeng/api';

interface SqsMessageItem {
  index: number;
  message: any;
  formatted: string;
  createdAt?: string;
  errorMessage?: string;
  errorType?: string;
}

@Component({
  selector: 'app-sqs-message-dialog',
  templateUrl: './sqs-message-dialog.component.html',
  styleUrls: ['./sqs-message-dialog.component.scss']
})
export class SqsMessageDialogComponent implements OnInit {
  sqsMessages: SqsMessageItem[] = [];
  selectedMessageIndex: number = 0;
  sqsMessageId: string | null = null;
  resending = false;
  hasMultipleMessages: boolean = false;

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private invoiceService: InvoiceService,
    private messageService: MessageService
  ) {
    this.sqsMessageId = this.config.data?.sqsMessageId;


    if (this.config.data?.sqsMessage) {
      this.processMessages(this.config.data.sqsMessage);
    }
  }

  ngOnInit() {

    if (!this.sqsMessageId || this.sqsMessageId === 'N/A') {
      return;
    }

    if (this.sqsMessages.length === 0) {
      this.invoiceService.getSqsMessageByMessageId(this.sqsMessageId).subscribe({
        next: (response) => {
          this.processMessages(response);
        },
        error: (err) => {
          console.error('Erro ao buscar mensagem SQS:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao carregar mensagem SQS: ' + (err.error?.message || err.message || 'Erro desconhecido')
          });
        }
      });
    }
  }

  processMessages(messages: any) {
    if (Array.isArray(messages)) {
      this.hasMultipleMessages = messages.length > 1;
      this.sqsMessages = messages.map((msg, index) => {
        const messageBody = msg.requestBody || msg;
        return {
          index: index + 1,
          message: messageBody,
          formatted: JSON.stringify(messageBody, null, 2),
          createdAt: msg.createdAt || msg.createDate || null,
          errorMessage: msg.errorMessage || null,
          errorType: msg.errorType || null
        };
      });
    } else {
      this.hasMultipleMessages = false;
      const messageBody = messages.requestBody || messages;
      this.sqsMessages = [{
        index: 1,
        message: messageBody,
        formatted: JSON.stringify(messageBody, null, 2),
        createdAt: messages.createdAt || messages.createDate || null,
        errorMessage: messages.errorMessage || null,
        errorType: messages.errorType || null
      }];
    }
  }

  get currentFormattedMessage(): string {
    if (this.sqsMessages.length > 0 && this.selectedMessageIndex >= 0 && this.selectedMessageIndex < this.sqsMessages.length) {
      return this.sqsMessages[this.selectedMessageIndex].formatted;
    }
    return '';
  }

  get currentMessage(): any {
    if (this.sqsMessages.length > 0 && this.selectedMessageIndex >= 0 && this.selectedMessageIndex < this.sqsMessages.length) {
      return this.sqsMessages[this.selectedMessageIndex].message;
    }
    return null;
  }

  close() {
    this.dialogRef.close();
  }

  copyToClipboard() {
    const textToCopy = this.currentFormattedMessage;
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Mensagem copiada para a área de transferência!' });
    }).catch(err => {
      console.error('Erro ao copiar:', err);
      this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao copiar mensagem' });
    });
  }

  resendToQueue() {
    if (!this.sqsMessageId || this.sqsMessageId === 'N/A') {
      this.messageService.add({ severity: 'warn', summary: 'Aviso', detail: 'SQS Message ID não encontrado' });
      return;
    }

    this.resending = true;
    this.invoiceService.resendSqsMessage(this.sqsMessageId).subscribe({
      next: (response) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Mensagem SQS reenviada para a fila com sucesso!'
        });
        this.resending = false;
        const currentMsg = this.currentMessage;
        if (currentMsg && currentMsg.status) {
          currentMsg.status = 'RESENDING';
          const currentItem = this.sqsMessages[this.selectedMessageIndex];
          currentItem.message = currentMsg;
          currentItem.formatted = JSON.stringify(currentMsg, null, 2);
        }
      },
      error: (err) => {
        console.error('Erro ao reenviar mensagem SQS:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao reenviar mensagem SQS: ' + (err.error?.message || err.message || 'Erro desconhecido')
        });
        this.resending = false;
      }
    });
  }

  selectMessage(index: number) {
    this.selectedMessageIndex = index;
  }

  formatDate(dateTime: string | null): string {
    if (!dateTime) return 'N/A';
    const date = new Date(dateTime);
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  }
}
